import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { IPC_AUDIO_DEVICE_CHANNELS } from '../../../../../../../dualChannel/dualChannelApis';
import { JsAudioDevice } from '../../../../../../../dualChannel/dualChannelTypes';
import useIsAppEnabled from '../../../../../../LiveContext/ApplicationSyncContext/useIsAppEnabled';

export default function useHandleDeviceUpdate() {
  const queryClient = useQueryClient();
  const isAppEnabled = useIsAppEnabled();

  React.useEffect(() => {
    if (isAppEnabled) {
      const port1 = window.audioDeviceAPI.subscribeToChanges();
      port1.onmessage = (e: MessageEvent<{ type: 'audio-device-change'; payload: { input: JsAudioDevice[]; output: JsAudioDevice[]; } }>) => {
        if (e.data.type === 'audio-device-change') {
          queryClient.setQueriesData({ queryKey: [IPC_AUDIO_DEVICE_CHANNELS.LIST_INPUT_DEVICES] }, e.data.payload.input);
          queryClient.setQueriesData({ queryKey: [IPC_AUDIO_DEVICE_CHANNELS.LIST_OUTPUT_DEVICES] }, e.data.payload.output);
        }
      };

      return () => {
        port1.close();
      };
    }
    return undefined;
  }, [isAppEnabled, queryClient]);
}
